export default {"src":"/_next/static/media/right-icon-blue.6eb64b96.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};